"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyArrayDataProvider = void 0;
// @ts-nocheck
const react_1 = require("react");
/**
 * This hook provides an array of data to the lazy loader modal. It basically simulates a typical http request based lazy loader
 * @param args
 */
const useLazyArrayDataProvider = (args) => {
    const { data, recordsPerPage } = args;
    const [currentData, setCurrentData] = react_1.useState(data);
    const [fetchedLength, setFetchedLength] = react_1.useState(Math.min(data.length, recordsPerPage));
    const addMoreData = react_1.useCallback((newData) => {
        setCurrentData(prev => [...prev, ...newData]);
    }, []);
    const fetchMoreData = react_1.useCallback(() => {
        setFetchedLength(prevIndex => Math.min(currentData.length, prevIndex + recordsPerPage));
    }, [currentData, recordsPerPage]);
    const fetchAllData = react_1.useCallback(() => {
        setFetchedLength(currentData.length);
    }, [currentData]);
    // If the passed in array changes, update to use that data
    react_1.useEffect(() => {
        setCurrentData(data);
    }, [data]);
    return {
        currentData,
        fetchedLength,
        addMoreData,
        fetchMoreData,
        fetchAllData,
    };
};
exports.useLazyArrayDataProvider = useLazyArrayDataProvider;
//# sourceMappingURL=useLazyArrayDataProvider.js.map